import { strings as stringManager } from '../../Strings';
export const moduleName = 'eeDetailsCard';
stringManager.load(moduleName, {
    department: 'Department',
    email: 'Email',
    employeeId: 'Employee ID',
    hireDate: 'Hire Date',
    location: 'Location',
    manager: 'Reports To'
});
const moduleStrings = stringManager[moduleName];
export { moduleStrings as strings };
export default moduleStrings;
